export default "__VITE_ASSET__7b7929ae__"